import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PipelineActivityService } from '../../../pipeline/services/pipeline-activity.service';
import { NoDataActionType, NoDataSourceType, NoDataTypes } from '../../interfaces/no-data';

@Component({
    selector: 'app-loan-card-risk',
    templateUrl: './loan-card-risk.component.html',
    styleUrls: ['./loan-card-risk.component.css'],
})
export class LoanCardRiskComponent implements OnInit, OnChanges {
    loading: boolean = false;
    data: any[];
    noDataSelection: NoDataTypes;

    @Input() loanNumber: string;
    constructor(private _activityService: PipelineActivityService, private datePipe: DatePipe) {}

    ngOnInit(): void {
        this.noDataSelection = {
            action: NoDataActionType.emptySelect,
            searchTerm: 'Milestones',
            componentTitle: 'loan risk',
            inputSource: NoDataSourceType.smallDataCard,
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        this.load();
    }

    load() {
        this.loading = true;

        try {
            this._activityService.getLoanRisk(this.loanNumber).subscribe(
                (res) => {
                    this.data = res;
                    if (this.data && this.data.length != 0) {
                        // Need to remove lock expiration!
                        this.data = this.data.filter((x) => x.riskCategory !== 'Lock Expiration');

                        for (let risk of this.data) {
                            if (risk.riskCategory === 'Fallout') {
                                risk.riskCategory = 'Fall Out';
                            }
                        }

                        // Need to remove fallout if it does not have a value!
                        let indexOfFallout = this.data.findIndex(
                            (x) => x.riskCategory === 'Fall Out'
                        );

                        if (indexOfFallout !== -1) {
                            if (!this.data[indexOfFallout].riskDate) {
                                this.data.splice(indexOfFallout, 1);
                            }
                        }

                        let indexOfLenderCredit = this.data.findIndex(
                            (x) => x.riskCategory == 'Lender Credit'
                        );
                        if (indexOfLenderCredit !== -1) {
                            if (!this.data[indexOfLenderCredit].riskValue) {
                                this.data.splice(indexOfLenderCredit, 1);
                            }
                        }

                        let indexOfTCure = this.data.findIndex(
                            (x) => x.riskCategory == 'Tolerance Cure'
                        );
                        if (indexOfTCure !== -1) {
                            if (!this.data[indexOfTCure].riskValue) {
                                this.data.splice(indexOfTCure, 1);
                            }
                        }

                        // This code is temp until 'Cure' is changed to 'Tolerance Cure'
                        let indexOfCure = this.data.findIndex((x) => x.riskCategory == 'Cure');
                        if (indexOfCure !== -1) {
                            this.data[indexOfCure].riskCategory = 'Tolerance Cure';
                            if (!this.data[indexOfCure].riskValue) {
                                this.data.splice(indexOfCure, 1);
                            }
                        }
                    }

                    this.loading = false;
                },
                (error) => {
                    throw error;
                }
            );
        } catch (e) {
            this.loading = false;
            this.data = null;
        }
    }

    formatRisk(item) {
        let data;
        try {
            if (item.riskValue || item.riskDate) {
                switch (item.riskCategory) {
                    case 'Credit Score': // numeric
                        data = `${item.riskValue}`;
                        break;
                    case 'B Ratio': // %
                    case 'Shock':
                        data = `${item.riskValue.toFixed(2)}%`;
                        break;
                    case 'Cash to Close': // $
                    case 'Total Assets': // $
                    case 'Lender Credit': //bps .000
                    case 'Tolerance Cure':
                    case 'Cure':
                        data = `$${this.numberWithCommas(item.riskValue.toFixed(0))}`;
                        break;
                    case 'Reserves (months)': // .00
                        data = item.riskValue.toFixed(2);
                        break;
                    case 'Interest Rate': // $.000
                        data = `${item.riskValue.toFixed(3)}%`;
                        break;
                    case 'Lock Expiration': // date
                    case 'Decisioned by UW':
                    case 'Fall Out':
                    case 'Commitment Date':
                        if (item.riskDate != null)
                            data = this.datePipe.transform(item.riskDate, 'MM/dd/yyyy', 'UTC');
                        else data = '';
                        break;
                }
            } else {
                data = '';
            }
        } catch (e) {
            data = '';
        }

        return data;
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
}
